/// <amd-module name="Core/Medius.Core.Web/Scripts/components/quickSearch/services/inboxManagerService"/>
import * as rest from "Core/Medius.Core.Web/Scripts/Medius/core/communication/json/rest";

export function tasksAssignmentsFor(documentId: number): JQueryPromise<any[]> {
    return rest.get("remedium-api/InboxManager/TasksAssignments", documentId);
}
